import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/api";

export const fetchAdminNotifications = createAsyncThunk(
  "notifications/fetchAdmin",
  async (params = {}, { rejectWithValue }) => {
    try {
      const res = await api.get("/notifications/admin", { params });
      return res.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to load notifications"
      );
    }
  }
);

export const sendNotificationsToUsers = createAsyncThunk(
  "notifications/sendToUsers",
  async (body, { rejectWithValue }) => {
    try {
      const res = await api.post("/notifications/send", body);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to send notifications"
      );
    }
  }
);

export const broadcastNotificationAction = createAsyncThunk(
  "notifications/broadcast",
  async (body, { rejectWithValue }) => {
    try {
      const res = await api.post("/notifications/broadcast", body);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to broadcast"
      );
    }
  }
);

const notificationSlice = createSlice({
  name: "notifications",
  initialState: {
    notifications: [],
    unreadCount: 0,
    adminNotifications: [],
    adminPagination: {
      total: 0,
      page: 1,
      limit: 20,
      totalPages: 0,
    },
    adminLoading: false,
    adminError: null,
    sendBusy: false,
  },
  reducers: {
    setNotifications: (state, action) => {
      state.notifications = action.payload;
    },
    setUnreadCount: (state, action) => {
      state.unreadCount = action.payload;
    },
    clearAdminNotificationError: (state) => {
      state.adminError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminNotifications.pending, (state) => {
        state.adminLoading = true;
        state.adminError = null;
      })
      .addCase(fetchAdminNotifications.fulfilled, (state, action) => {
        state.adminLoading = false;
        state.adminNotifications = action.payload.notifications || [];
        const p = action.payload.pagination || {};
        state.adminPagination = {
          total: p.total ?? 0,
          page: p.page ?? 1,
          limit: p.limit ?? 20,
          totalPages: p.totalPages ?? 0,
        };
      })
      .addCase(fetchAdminNotifications.rejected, (state, action) => {
        state.adminLoading = false;
        state.adminError = action.payload;
      })
      .addCase(sendNotificationsToUsers.pending, (state) => {
        state.sendBusy = true;
      })
      .addCase(sendNotificationsToUsers.fulfilled, (state) => {
        state.sendBusy = false;
      })
      .addCase(sendNotificationsToUsers.rejected, (state) => {
        state.sendBusy = false;
      })
      .addCase(broadcastNotificationAction.pending, (state) => {
        state.sendBusy = true;
      })
      .addCase(broadcastNotificationAction.fulfilled, (state) => {
        state.sendBusy = false;
      })
      .addCase(broadcastNotificationAction.rejected, (state) => {
        state.sendBusy = false;
      });
  },
});

export const {
  setNotifications,
  setUnreadCount,
  clearAdminNotificationError,
} = notificationSlice.actions;

export default notificationSlice.reducer;
